import { useState } from 'react';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler, { isBookingGone } from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

const useGetBooking = () => {
  const { tenantId } = useTenant();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();

  // Resolves to `true` when the booking no longer exists, so the caller can stop waiting for it.
  // The snackbar saying so is already shown by then.
  const getBooking = async (bookingId) => {
    setLoading(true);

    try {
      const url = `/v1/tenants/${tenantId}/bookings/${bookingId}`;
      const response = await apiClient.get(url);
      setData(response.data);
      return false;
    } catch (error) {
      handleError(error, Routes.DASHBOARD);
      return isBookingGone(error);
    } finally {
      setLoading(false);
    }
  };

  return { getBooking, data, loading };
};

export default useGetBooking;
